import { useModal } from "context/hooks/useModal";
import { useState } from "react";
import axiosInstance from "utils/axios";
import { ApiResponse } from "constantVariables";
import { showToast } from "utils/toast";
import OutlinedButton from "components/common/Button/OutlinedButton";
import PrimaryButton from "components/common/Button/PrimaryButton";
import { t } from "i18next";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";

const ReportProblemModal = ({ lifeChoice, activeTab }) => {
  const { hideModal } = useModal();
  const [inputValues, setInputValues] = useState({
    subject: "Wrong data",
    description: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = () => {
    setLoading(true);
    setError("");
    axiosInstance
      .post("/report-problem", {
        ...inputValues,
        tab: activeTab,
        page: lifeChoice?._id,
      })
      .then((res) => res.data)
      .then((res) => {
        setLoading(false);
        if (res.statusCode === ApiResponse.CREATED) {
          showToast(t("reportAProblemSuccessMessage"));
          hideModal();
        } else {
          setError(t("reportAProblemFailMessage"));
          showToast(t("reportAProblemFailMessage"));
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(t("reportAProblemFailMessage"));
        console.log(err);
        hideModal();
      });
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <div>
        <h3 className="text-theme-blue text-xl text-bold">
          {t("reportAProblemTitle")}
        </h3>
        {error && <p className="text-red-400 m-0 text-sm">{error}</p>}
      </div>
      <select
        className="border border-gray-500 rounded-md p-1"
        onChange={(e) =>
          setInputValues({ ...inputValues, subject: e.target.value })
        }
        selected={inputValues.subject}
      >
        <option value="Wrong data">{t("reportAProblemOptionWrongData")}</option>
        <option value="Application problem">
          {t("reportAProblemOptionApplicationProblem")}
        </option>
        <option value="Something else">
          {t("reportAProblemOptionSomethingElse")}
        </option>
      </select>
      <div>
        <textarea
          id="report"
          placeholder={t("reportAProblemDescription")}
          rows={5}
          className="border border-gray-500 rounded-md p-1 resize-none w-full"
          onChange={(e) =>
            setInputValues({
              ...inputValues,
              description: e.target.value,
            })
          }
          value={inputValues.description}
          maxLength={500}
        ></textarea>
        <p className="text-xs text-gray-400 m-0 text-right">
          {t("reportAProblemDescriptionLimit", {
            counter: inputValues.description.length ?? 0,
          })}
        </p>
      </div>
      <div className="flex items-center gap-4 justify-end">
        <OutlinedButton className="rounded-md" onClick={() => hideModal()}>
          {t("reportAProblemCancelButton")}
        </OutlinedButton>
        <PrimaryButton
          className="rounded-md py-1 px-2 w-1/4 self-center disabled:opacity-50"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? t("loading") : t("reportAProblemSubmitButton")}
        </PrimaryButton>
      </div>
    </div>
  );
};

const ReportProblem = ({ className }) => {
  const { showModal } = useModal();
  const { lifeChoice, activeTab } = useLifeChoicePageContext();

  const reportProblemHandler = () => {
    showModal(
      <ReportProblemModal activeTab={activeTab} lifeChoice={lifeChoice} />,
      "sm"
    );
  };
  return (
    <button
      className={`text-theme-blue font-heebo underline text-sm lg:text-lg cursor-pointer ${className}`}
      onClick={reportProblemHandler}
    >
      {t("reportAProblem")}
    </button>
  );
};

export default ReportProblem;
